import { createSelector } from 'reselect';

const supplierPrivateInquiriesStateSelector = state =>
  state.CustomerPrivateSupplierInquiries;

const selectById = (state, itemId) => itemId;

export const supplierPrivateInquiriesSelector = createSelector(
  [supplierPrivateInquiriesStateSelector],
  inquiries => inquiries.items
);

export const inquiryByIdSelector = createSelector(
  [supplierPrivateInquiriesSelector, selectById],
  (inquiries, _id) => {
    const inquiry = inquiries.find(item => _id === item._id);
    if (!inquiry) return null;
    return inquiry;
  }
);

export const supplierPrivateInquiriesIsLoadingSelector = createSelector(
  [supplierPrivateInquiriesStateSelector],
  inquiries => inquiries.isLoading
);

export const PrivateSupplierListSelector = createSelector(
  [supplierPrivateInquiriesSelector],
  inquiries =>
    inquiries.map(inquiry => ({
      name: inquiry.businessName,
      message: inquiry.message,
      _id: inquiry._id,
      moderated: inquiry.moderated,
      productName: inquiry.aproductName,
      supplierProduct: inquiry.supplierProduct,
      active: inquiry.active,
      proposalLength:
        typeof inquiry.proposal === 'object'
          ? Object.keys(inquiry.proposal).length
          : inquiry.proposal.length
    }))
);

export const inquiryCountSelector = createSelector(
  [supplierPrivateInquiriesStateSelector],
  inquiry => inquiry.count
);

export const inquiryStagingSelector = createSelector(
  [supplierPrivateInquiriesStateSelector],
  inquiry => inquiry.staging
);

export const inquiryStagingCountSelector = createSelector(
  [supplierPrivateInquiriesStateSelector],
  inquiry => inquiry.stagingCount
);

export const inquiryStagingByIdSelector = createSelector(
  [inquiryStagingSelector, selectById],
  (inquiries, _id) => {
    const inquiry = inquiries.find(item => _id === item._id);
    if (!inquiry) return null;
    return inquiry;
  }
);
